export const giftCardForm = {
  form: {
    position: "relative"
  },
  checkButton: {
    verticalAlign: "middle",
    color: "#FFF",
    backgroundColor: "#3EB9D0",
    position: "relative",
    marginLeft: "10px",
    marginRight: "10px",
    padding: "0 20px",
    float: "left",
    marginTop: "20px"
  },
  inputStyle: {
    position: "relative",
    float: "left",
    margin: "0 2%"
  },
  clearFloatContainer: {
    clear: "both"
  },
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  avatarSyle: {
    fontSize: "1.2em"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  titleStyle: {
    textTransform: "capitalize"
  }
};

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    width: "100%"
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const giftCardSimpleForm = {
  form: {
    position: "relative"
  },
  inputsContainer: {
    // borderBottom: "2px solid #76C5C1",
    marginBottom: "20px",
    paddingBottom: "20px",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px"
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/GiftCards/style.js